import { useState } from 'react';
import { useShareUrl } from '../hooks/useShareUrl';
import { ResponseControls } from './ResponseControls';

// Body type, status, delay and drip, then the crafted URL they produce.
export function UrlBar() {
  const url = useShareUrl();
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1200);
    });
  };
  return (
    <div className="url-bar">
      <ResponseControls />
      <input readOnly value={url} onFocus={(e) => e.currentTarget.select()} aria-label="Crafted URL" spellCheck={false} />
      <span className="url-bar-length" title="Length of the URL in characters">{url.length}</span>
      <button type="button" className="url-copy" onClick={copy} title="Copy URL to clipboard" aria-label="Copy URL">
        {copied ? '✓' : '⎘'}
      </button>
    </div>
  );
}
